// extracted by mini-css-extract-plugin
export default {"container":"MyEstablishments_container__WHSUO","title":"MyEstablishments_title__2kNTN"};